module.exports = __webpack_public_path__ + "img/palmar-room-2.d96b36ec.jpg";